export const EQUIPMENT_TYPES = ["Dry Van", "Reefer", "Flatbed", "Intermodal"];

export const RATE_TYPES = [
  "New lane",
  "Renewal",
  "Spot",
  "Contract",
  "Backhaul",
];

